import { TopRankTable } from '../TopRankTable'
import { withTopWriterTable } from './withTopWriterTable'

const ConnectedTopWriterTable = withTopWriterTable(TopRankTable)

export { ConnectedTopWriterTable as TopWriterTable }
